export class NoActiveSubscriptionException {}